import request from '@/utils/request';

// 供应商列表
export const supplierList = (data: any): any =>
  request({
    url: '/provider/list',
    data: data
  })

// 新增供应商
export const creareSupplier = (data: any): any =>
  request({
    url: '/provider/create',
    data: data
  })

// 供应商详情
export const supplierInfo = (data: any): any =>
  request({
    url: '/provider/provider/providerInfo',
    data: data
  })

// 设置供应商
export const setSupplier = (data: any): any =>
  request({
    url: '/provider/provider/providerInfoEdit',
    data: data
  })

// 供应商统计
export const getProviderStatistics = (data: any): any =>
  request({
    url: '/provider/statistics',
    data: data
  })

// 供应商统计_详情列表
export const getProviderProductEarnings = (data: any): any =>
  request({
    url: '/provider/product/earnings',
    data: data
  })

// 商品列表
export const productList = (data: any): any =>
  request({
    url: '/product/backend/list',
    data: data
  })

// 商品详情
export const productInfo = (data: any): any =>
  request({
    url: '/provider/product/productInfo',
    data: data
  })

// 获取单位列表
export const productUnitList = (data: any): any =>
  request({
    url: '/provider/product/productUnitList',
    data: data
  })

// 创建商品
export const createProduct = (data: any): any =>
  request({
    url: '/provider/product/providerSaveProduct',
    data: data
  })

// 更新商品
export const updateProduct = (data: any): any =>
  request({
    url: '/product/update',
    data: data
  })

// 删除商品
export const delProduct = (data: any): any =>
  request({
    url: '/product/delete',
    data: data
  })

// 获取供应商商品列表
export const getProviderProductList = (data: any) =>
  request({
    url: '/provider/product/produtList',
    data: data
  })

// 供应商商品寄样物流信息
export const productsampleSend = (data: any) =>
  request({
    url: '/provider/product/sampleSend',
    data: data
  })

// 获取采购列表
export const productBuyerproductBuyerSelectItem = (data: any): any =>
request({
  url: '/provider/productBuyer/productBuyerSelectItem',
  data: data
})
// 获取排期商品详情
export const productscheduleProductDetail = (data: any): any =>
request({
  url: '/provider/product/scheduleProductDetail',
  data: data
})
// 获取商品供货商供货价
export const productproductProviderSupplyPrice = (data: any): any =>
request({
  url: '/provider/product/productProviderSupplyPrice',
  data: data
})